const addCryptRouteId = cryptId => {
  let str = atob(cryptId)
  let start = str.indexOf('#mai#') + 5
  let end = str.indexOf('#mai#', start)
  return str.substring(start, end)
}

const createRouteIdHash = id => {
  let hash = new Date().getTime() / 1000
  return btoa(`${hash}#mai#${id}#mai#${hash}`)
}

const transformQueryString = data => {
  let req = {}
  for (let prop in data) {
    if (typeof data[prop] === 'object' && typeof data[prop] !== 'undefined' && data[prop] !== null && data[prop].hasOwnProperty('id')) {
      req[prop] = String(data[prop].id)
    } else if (typeof data[prop] !== 'object' && data[prop] !== null && data[prop] !== '') {
      req[prop] = String(data[prop])
    }
  }
  return req
}

const decryptQueryString = params => {
  let obj = {}
  for (let prop in params) {
    obj[atob(prop)] = atob(params[prop])
  }
  return obj
}

const cryptQueryString = params => {
  let obj = {}
  for (let prop in params) {
    obj[btoa(prop)] = btoa(params[prop])
  }
  return obj
}

export {
  addCryptRouteId,
  createRouteIdHash,
  cryptQueryString,
  decryptQueryString,
  transformQueryString
}



// WEBPACK FOOTER //
// ./src/modules/helpers/RouteHash.js